module.exports = __webpack_public_path__ + "media/images/shared/icon-medicalWaiver-45aab03f66cd7f918431987195be03d9.png";